import { useEffect } from "react";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/performance";
import { getCLS, getFID, getLCP, getTTFB } from "web-vitals";

export default function ClientSideOnly(): React.ReactElement {
  useEffect(() => {
    const analytics = firebase.analytics();
    const perf = firebase.performance();
    console.log("FirebaseClientSideOnly initialized", { analytics, perf });
    getTTFB(console.log);
    getCLS(console.log);
    getFID(console.log);
    getLCP(console.log);
  });
  return <div id="analytics" />;
}
